import { render, staticRenderFns } from "./newTotalOnlinePeople.vue?vue&type=template&id=0ae6088e&scoped=true"
import script from "./newTotalOnlinePeople.vue?vue&type=script&lang=js"
export * from "./newTotalOnlinePeople.vue?vue&type=script&lang=js"
import style0 from "./newTotalOnlinePeople.vue?vue&type=style&index=0&id=0ae6088e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae6088e",
  null
  
)

export default component.exports